const getters = {
  sidebar: state => state.app.sidebar,
  permisson_routes: state => state.permission.routes,
  // 过滤了hiddenMenu
  showRoutes: state => {
     // 这个只适合二级菜单  多级需要重写方法
     return state.permission.routes.filter(item => item.meta && item.meta.title && !item.hiddenMenu).map(item => {
      if (item.children && item.children.length) {
        item.children = item.children.filter(child => child.meta && child.meta.title && !child.hiddenMenu)
      }
      return item
    })
  },
  // 学生端
  stuRoutes: state => state.permission.routes_stu,
}

export default getters